module.exports = __webpack_public_path__ + "img/system_last.5a577f09.png";